import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import { LookupAlumnoCarrera } from '../AlumnoCarrera/LookupAlumnoCarrera';
import * as constantClass from '../fileWithConstants';
import * as estadoCurricularService from '../../services/estadoCurricular/estadoCurricularService';
import { classifyEstadoCurricularError, downloadPdfFromBase64 } from '../../services/estadoCurricular/estadoCurricularDto';
import { ChevronLeftIcon } from '../common/mdPageIcons';

export class GenerateEstadoCurricular extends Component {
  static displayName = GenerateEstadoCurricular.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showErrorMessage: false,
      success: false,
      errorMessage: '',
      showLookupAlumnos: false,
      alumno: { codigo: '', descripcion: '' },
    };
  }

  async componentDidMount() {
    await constantClass.canAccess('WWCertificados');
  }

  handleConfirmButton = () => {
    if (this.isOkToSave()) {
      this.generateCertificate();
    } else {
      this.setState({ showErrorMessage: true, errorMessage: 'Todos los campos son obligatorios' });
    }
  };

  handleShowLookup = () => {
    this.setState({ showLookupAlumnos: true });
  };

  handleHideLookup = () => {
    this.setState({ showLookupAlumnos: false });
  };

  handleSelectAlumnoItem = (e) => {
    const properties = e.split('%');
    this.setState({
      showLookupAlumnos: false,
      alumno: {
        codigo: properties[0],
        descripcion: properties[1] + ' - ' + properties[2],
      },
      showErrorMessage: false,
      errorMessage: '',
      success: false,
    });
  };

  render() {
    const { loading } = this.state;

    return (
      <div className="md-page md-estado-curricular">
        <Link className="md-page__back-link" to="/md-axc">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Generar Estado Curricular</h1>
        </div>
        <p className="md-page__subtitle">
          Seleccione el alumno por carrera para generar el certificado en PDF.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Generando el certificado espere</div>
          ) : null}
          {this.state.success && !loading ? (
            <div className="md-page__success">Certificado generado exitosamente</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Alumno por carrera</span>
            {!loading ? (
              <button type="button" className="md-page__picker-link" onClick={this.handleShowLookup}>
                Seleccionar alumno por carrera
              </button>
            ) : null}
            {this.state.showLookupAlumnos ? (
              <LookupAlumnoCarrera
                selectItem={this.handleSelectAlumnoItem}
                hideLookup={this.handleHideLookup}
              />
            ) : null}
            <div className="md-page__field-readonly">
              {this.state.alumno.descripcion || 'Ningún alumno seleccionado'}
            </div>
          </div>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Generar Certificado
            </button>
          </div>
        </div>
      </div>
    );
  }

  isOkToSave() {
    return this.state.alumno.descripcion.length > 1;
  }

  handleEstadoCurricularError(error, prefix = '') {
    const outcome = classifyEstadoCurricularError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return { success: false, errorMessage: '' };
    }
    return {
      success: false,
      errorMessage: outcome.message,
    };
  }

  async generateCertificate() {
    this.setState({ showErrorMessage: false, loading: true, success: false });
    try {
      const returnModel = await estadoCurricularService.generarEstadoCurricular(this.state.alumno.codigo);
      downloadPdfFromBase64(returnModel, 'estadoCurricular.pdf');
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = this.handleEstadoCurricularError(error);
      this.setState({
        loading: false,
        success: outcome.success,
        errorMessage: outcome.errorMessage,
        showErrorMessage: true,
      });
    }
  }
}
